<template>

    <div class="modal fade" id="downloadTrackCollectionModal" tabindex="-1" role="dialog" aria-labelledby="downloadTrackCollectionModalTitle" aria-hidden="true">

        <div class="modal-dialog modal-lg" role="document">

            <div class="modal-content">

                <div class="modal-header">

                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <i class="material-icons">close</i>
                    </button>

                    <h5 class="modal-title">
                        Download {{ resourceType }} Tracks
                    </h5>

                </div>

                <div class="modal-body">

                    <div v-if="resourceName">

                        <div class="download-resource-name">
                            {{ resourceName }}
                        </div>

                        <div class="download-resource-trackcount text-stardust-grey" v-if="resourceTrackcount">
                            ({{ resourceTrackcount }} tracks)
                        </div>

                        <p class="select-file-types-title">
                            Select file type
                        </p>

                        <div class="select-file-types-container">

                            <div class="row">

                                <div class="col-sm-12 col-lg-8 mx-auto">

                                    <div class="row">

                                        <div class="col-sm-4">

                                            <a href="#" @click.prevent="fileTypeChosen = 'wav'" v-bind:class="{ 'active': ( fileTypeChosen == 'wav' ) }" class="file-type border border-stardust-grey">
                                                <span class="file-type-text">WAV</span>
                                                <i class="material-icons active-icon">done</i>
                                            </a>

                                        </div>

                                        <div class="col-sm-4">

                                            <a href="#" @click.prevent="fileTypeChosen = 'mp3'" v-bind:class="{ 'active': ( fileTypeChosen == 'mp3' ) }" class="file-type border border-stardust-grey">
                                                <span class="file-type-text">MP3</span>
                                                <i class="material-icons active-icon">done</i>
                                            </a>

                                        </div>

                                        <div class="col-sm-4">

                                            <a href="#" @click.prevent="fileTypeChosen = 'aiff'" v-bind:class="{ 'active': ( fileTypeChosen == 'aiff' ) }" class="file-type border border-stardust-grey">
                                                <span class="file-type-text">AIFF</span>
                                                <i class="material-icons active-icon">done</i>
                                            </a>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                        <a href="#" class="btn btn-raised btn-danger btn-xl font-weight-semibold start-download-button" @click.prevent="onClickDownload">
                            Start download
                        </a>

                        <!--<div class="mt-3">

                            <small class="text-muted" v-if="downloadGenerating">Once the download has initialised, you can close this download modal. A new browser tab may open up to generate the download. It will close after the download has begun.</small>

                        </div>-->

                    </div>

                </div>

                <div class="modal-footer">
                    &nbsp;
                </div>

            </div>

        </div>

    </div>

</template>

<script>

	import Vue from 'vue';
	import { playerService } from '../player-service';

	export default Vue.component(
	  'download-track-collection',
	  {

		  data: function () {

			  return {

				  resourceName: null,
				  resourceId: null,
				  resourceType: null,
				  resourceTrackcount: null,
                  fileTypeChosen: window.authenticatedUserFileType,
                  downloadGenerating: false

			  };

		  },

		  mounted: function () {

              playerService.$on( 'user-updated', () => {

                  this.fileTypeChosen = window.authenticatedUserFileType;

              } );

			  // Change the download modal contents depending on whats passed to it.
			  playerService.$on(
				'open-download-track-collection',
				( resourceName, resourceId, resourceType, resourceTrackcount ) => {

				    this.reset();

					this.resourceName = resourceName;
					this.resourceId = resourceId;
					this.resourceType = resourceType;
					this.resourceTrackcount = resourceTrackcount;
					this.downloadGenerating = false;

					// Open the modal.
					window.webpackOpenBsModalWorkaround( '#downloadTrackCollectionModal' );

				}
			  );

		  },

          methods: {

		      onClickDownload: function() {

                  if( !this.fileTypeChosen ) {
                      this.fileTypeChosen = 'mp3';
                  }

                  window.webpackCloseBsModalWorkaround( '#downloadTrackCollectionModal' );

                  this.downloadGenerating = true;

		          playerService.downloadTrackCollection( this.resourceType, this.resourceId, this.fileTypeChosen, this.resourceTrackcount );

              },


              reset: function() {

                  this.resourceName = null;
                  this.resourceId = null;
                  this.resourceType = null;
                  this.resourceTrackcount = null;
                  this.downloadGenerating = false;
                  this.fileTypeChosen = window.authenticatedUserFileType;

              }

          }

	  }
	);

</script>
